import { useQuery } from "@tanstack/react-query";
import { getMerchantsMerchantPricings } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const MERCHANTS_PRICINGS_QUERY_KEY = "MERCHANTS_PRICINGS";

export const getMerchantPricingsQueryKey = () => [MERCHANTS_PRICINGS_QUERY_KEY];

export const useGetMerchantPricingsQuery = () =>
  useQuery({
    queryKey: getMerchantPricingsQueryKey(),
    queryFn: processResponseWithApiProblemDetails(() =>
      getMerchantsMerchantPricings(),
    ),
  });
